export const DEFAULT_PAGE_SIZE_OPTIONS = [25, 50, 100, 250, 500, 1000];

/** Max rows fetched for select/filter dropdowns (server search can extend later). */
export const SELECT_PAGE_LIMIT = 100;

/** Max page size offered on data tables. */
export const TABLE_PAGE_LIMIT_MAX = 250;

export const TABLE_PAGE_SIZE_OPTIONS = [25, 50, 100, TABLE_PAGE_LIMIT_MAX] as const;

/** Cap accumulated rows on mobile infinite-scroll lists. */
export const MOBILE_LIST_ACCUMULATED_MAX = 200;

type ResolvePaginationTotalArgs = {
    total?: number;
    totalRows?: number;
    totalQuantity?: number;
    pages?: number;
    pageSize?: number;
};

/** Total row count for Ant Design Pagination when API returns only pages. */
export function resolvePaginationTotal({
    total,
    totalRows,
    totalQuantity,
    pages,
    pageSize = 25,
}: ResolvePaginationTotalArgs): number {
    const explicit = total ?? totalRows ?? totalQuantity;
    if (explicit != null && explicit >= 0) {
        return explicit;
    }
    if (pages != null && pages > 0) {
        return pages * pageSize;
    }
    return 0;
}

type LegacyFilterChange = (e: unknown, objectKey: string, index?: number) => void;

/** Bridge legacy handleFilterChange to TablePagePagination callbacks. */
export function legacyFilterPaginationHandlers(handleFilterChange: LegacyFilterChange) {
    return {
        onPageChange: (page: number) => {
            handleFilterChange(
                {target: {options: [{value: page}], selectedIndex: 0}},
                'page',
                page - 1,
            );
        },
        onPageSizeChange: (pageSize: number) => {
            handleFilterChange(
                {target: {options: [{value: pageSize}], selectedIndex: 0}},
                'page_limit',
            );
        },
    };
}

/** Standard mobx filter setter used across list pages. */
export function createFilterPaginationHandlers(
    setFilter: (patch: {page?: number; page_limit?: number}) => void,
) {
    return {
        onPageChange: (page: number) => setFilter({page}),
        onPageSizeChange: (page_limit: number) => setFilter({page_limit}),
    };
}
